import { ChangeEvent, useEffect, useState } from 'react';
import Products from '../interfaces/Product';
import { FormInterface } from '../../../core/interfaces/form/Form';
import FormLabel from '../../../component/input/FormLabel.component';
import { FormSelect } from '../../../component/input/InputStyle';
import MenuItem from '@material-ui/core/MenuItem';
import { INITIAL_VALUES } from '../utils/INITIAL_VALUES';
import { Container } from '../../../component/container/Container';
import CardComponent from '../../../component/card/Card.component';
import { useProducts } from '../../../context/SearchProduct';
import RangeSlider from '../../../component/slide/RangeSlider.component';

export default function Form({ handleSubmitForm, initialValues }: FormInterface<Products[]>) {

  const [values, setValues] = useState<Products>(INITIAL_VALUES);
  const [brands, setDrands] = useState<Set<string>>(new Set([]));
  const [sectors, setSectors] = useState<Set<string>>(new Set([]));
  const [sections, setSections] = useState<Set<string>>(new Set([]));
  const [groups, setGroups] = useState<Set<string>>(new Set([]));
  const [subgroups, setSubgroups] = useState<Set<string>>(new Set([]));
  const [families, setFamilies] = useState<Set<string>>(new Set([]));
  const [min, setMin] = useState<number>(0);
  const [max, setMax] = useState<number>(0);
  const [reload, setReload] = useState<boolean>(false);

  const { filterSearch, setFilterSearch } = useProducts();

  useEffect(() => {
    setValues(filterSearch);
    let min: number = Number(initialValues[0].VIGENTE);
    let max: number = Number(initialValues[0].VIGENTE);
    initialValues.map((product: Products) => {
      setDrands(add(brands, product.MARCA || ''));
      setSectors(add(sectors, product.SETOR || ''));
      setSections(add(sections, product.SECAO || ''));
      setGroups(add(groups, product.GRUPO || ''));
      setSubgroups(add(subgroups, product.SUBGRUPO || ''));
      setFamilies(add(families, product.GRPMERCADORIA || ''));

      if (Number(product.VIGENTE) < min) {
        min = Number(product.VIGENTE);
      }

      if (Number(product.VIGENTE) > max) {
        max = Number(product.VIGENTE);
      }
      return product;
    });
    setMin(min);
    setMax(max);
    setReload(true);
  }, [initialValues]);// eslint-disable-line react-hooks/exhaustive-deps

  const add = (setArray: Set<string>, value: string): Set<string> => {
    return setArray.add(value);
  }

  const handleChange = (event: ChangeEvent<{ name?: string, value: unknown }>) => {
    const { name, value } = event.target;
    let valueAux: Products = INITIAL_VALUES;
    if (name) {
      setValues({ ...values, [name]: value });
      valueAux = { ...values, [name]: value };
    }
    setFilterSearch(valueAux);
    handleSubmitForm([valueAux]);
  }

  const setValuesRange = (range: number[]) => {
    setValues({ ...values, VIGENTE: `${range[0]}`, REGULAR: `${range[1]}` });
    handleSubmitForm([{ ...values, VIGENTE: `${range[0]}`, REGULAR: `${range[1]}` }]);
  }

  if (!reload) {
    return <></>
  }

  return (
    <form>
      <CardComponent padding="10px 10px 10px 10px">
        <FormLabel title="Marca" sm={12} >
          <FormSelect
            name="MARCA"
            value={values.MARCA || '0'}
            onChange={handleChange}
            defaultValue="0"
            required
          >
            <MenuItem value="0" >Todos</MenuItem>
            {[...Array.from(brands)].map((statusValues: string, index: number) => {
              return <MenuItem value={statusValues || index} key={index}>{statusValues}</MenuItem>
            })}
          </FormSelect>
        </FormLabel>
        <Container margin={'10px 0px'}>
          <FormLabel title="Setor" sm={12} >
            <FormSelect
              name="SETOR"
              value={values.SETOR || '0'}
              onChange={handleChange}
              defaultValue="0"
              required
            >
              <MenuItem value="0" >Todos</MenuItem>
              {[...Array.from(sectors)].map((statusValues: string, index: number) => {
                return <MenuItem value={statusValues || index} key={index}>{statusValues}</MenuItem>
              })}
            </FormSelect>
          </FormLabel>
        </Container>
        <Container margin={'10px 0px'}>
          <FormLabel title="Seção" sm={12} >
            <FormSelect
              name="SECAO"
              value={values.SECAO || '0'}
              onChange={handleChange}
              defaultValue="0"
              required
            >
              <MenuItem value="0" >Todos</MenuItem>
              {[...Array.from(sections)].map((statusValues: string, index: number) => {
                return <MenuItem value={statusValues || index} key={index}>{statusValues}</MenuItem>
              })}
            </FormSelect>
          </FormLabel>
        </Container>
        <Container margin={'10px 0px'}>
          <FormLabel title="Grupo" sm={12} >
            <FormSelect
              name="GRUPO"
              value={values.GRUPO || '0'}
              onChange={handleChange}
              defaultValue="0"
              required
            >
              <MenuItem value="0" >Todos</MenuItem>
              {[...Array.from(groups)].map((statusValues: string, index: number) => {
                return <MenuItem value={statusValues || index} key={index}>{statusValues}</MenuItem>
              })}
            </FormSelect>
          </FormLabel>
        </Container>
        <Container margin={'10px 0px'}>
          <FormLabel title="SubGrupo" sm={12} >
            <FormSelect
              name="SUBGRUPO"
              value={values.SUBGRUPO || '0'}
              onChange={handleChange}
              defaultValue="0"
              required
            >
              <MenuItem value="0" >Todos</MenuItem>
              {[...Array.from(subgroups)].map((statusValues: string, index: number) => {
                return <MenuItem value={statusValues || index} key={index}>{statusValues}</MenuItem>
              })}
            </FormSelect>
          </FormLabel>
        </Container>
        <Container margin={'10px 0px'}>
          <FormLabel title="Familia" sm={12} >
            <FormSelect
              name="GRPMERCADORIA"
              value={values.GRPMERCADORIA || '0'}
              onChange={handleChange}
              defaultValue="0"
              required
            >
              <MenuItem value="0" >Todos</MenuItem>
              {[...Array.from(families)].map((statusValues: string, index: number) => {
                return <MenuItem value={statusValues || index} key={index}>{statusValues}</MenuItem>
              })}
            </FormSelect>
          </FormLabel>
        </Container>
        <Container margin={'10px 0px'}>
          <FormLabel title="Preço" sm={12} >
            <RangeSlider min={min} max={max} values={setValuesRange} />
          </FormLabel>
        </Container>
      </CardComponent>
    </form>
  )
}
